import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css'
import Singleton from './Components/Singleton';

const getToken = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_REDA_URL}authenticate`, {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            },
            method: "POST",
            body: JSON.stringify({
                username: process.env.REACT_APP_REDA_USER,
                password: process.env.REACT_APP_REDA_PASS
            })
        })

        const content = await response.json()

        return content.id_token;
    } catch (e) {
        console.log(e)
        return false
    }
}

const PreRender = () => {

    const [token, setToken] = React.useState(false)

    const resolve = async () => {
        const token = await getToken()
        if (!token) {
            setToken(false)
        } else {
            Singleton.getInstance(token)
            setToken(token)
        }
    }

    React.useEffect(() => {
        resolve();
    }, [])

    return token ? <App /> : null
}

ReactDOM.render(
    <React.StrictMode>
        <PreRender />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
